
const
    axios = require('axios'),
    when = require('when');

function Copydeck (options) {
    if (!(this instanceof Copydeck)) return new Copydeck(options);

    const self = this;

    options = options || {};

    const apiBase = options.apiBase || '/api';
    const multipleRequestMaxNodes = options.multipleRequestMaxNodes || 50;
    const multipleRequestDebounceDelay = options.multipleRequestDebounceDelay || 25;

    const copyCache = this._copyCache = {};

    const queue = this._queue = {};
    let timeout = 0;

    // Function to request a node from the server or node cache.
    this.get = function _getDebounced (node, locale) {
        if (copyCache[locale] === undefined) {
            copyCache[locale] = {};
        }
        if (copyCache[locale][node]) {
            return when(copyCache[locale][node]);
        }

        if (!queue[locale]) {
            queue[locale] = [];
        }

        return when.promise((resolve, reject) => {
            queue[locale].push({
                node,
                resolve,
                reject,
            });

            if (timeout) {
                clearTimeout(timeout);
            }

            if (queue.length >= multipleRequestMaxNodes) {
                fetchQueue();
            }
            else {
                timeout = setTimeout(fetchQueue, multipleRequestDebounceDelay);
            }
        });
    };

    this._getCopy = function _getCopy (nodes, locale) {
        const nodesString = nodes.sort().join(',');

        return when(axios.get(apiBase + '/copydeck/' + locale, {
            params: { nodes: nodesString },
        }))
        .then(({ data }) => {
            Object.keys(data).forEach(function _cacheNode (key) {
                copyCache[locale][key] = data[key];
            });

            return data;
        });
    };

    function fetchQueue () {
        for (const locale in queue) {
            // Copy and empty the current queue.
            const toFetch = queue[locale].slice();
            queue[locale].length = 0;

            // Reset timeout.
            timeout = 0;

            if (toFetch.length <= 0) {
                continue;
            }

            const nodes = toFetch.map(function _queueToNodeString (item) {
                return item.node;
            });

            self._getCopy(nodes, locale)
            .then(function _resolveQueuedNodes (result) {
                return toFetch.forEach((item) =>
                    // If the node we're looking for was empty, it will
                    // not be in the response. This is the intended behavior,
                    // so we'll just assume it was empty here.
                    item.resolve(result[item.node] || ''));
            })
            .catch(function _rejectQueuedNodes (err) {
                return toFetch.forEach((item) => item.reject(err));
            });
        }
    }
}

module.exports = new Copydeck();
module.exports.Copydeck = Copydeck;
